module.exports = __webpack_public_path__ + "media/playstore.e3155375.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/app-website/assets/playstore.svg
// module id = ./src/templates/app-website/assets/playstore.svg
// module chunks = 0